export default __webpack_public_path__ + "static/media/Sharjah-Mun-Logo1.e31fc12e.svg";